// FNP-565: `nextToken` was declared as a variable and passed to the resolver,
// but never SELECTED in the result set — so the server paginated correctly and
// the browser threw the cursor away on every response. The list could only ever
// show page one, and no caller could tell that more existed.
export const listPlaybooks = `
   query listPlaybooks($filter: PlaybooksFilterInput, $limit: Int, $nextToken:  String) {
       listPlaybooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              displayName
              description
              stateMachineArn
              inputSchema
              category
              status
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getPlaybook = `
   query getPlaybook($id:ID!) {
       getPlaybook(id:$id) {
         id
         name
         displayName
         description
         stateMachineArn
         inputSchema
         category
         status
         createdByUsername
         created
         updated
       }
}`;

// FNP-1011: the whole tree in ONE request, for export.
//
// getPlaybook above deliberately stays flat — every existing caller renders a
// single record and would pay for phases and steps it never displays.
//
// ⚠️ `parameters` is AWSJSON, and AppSync DOUBLE-WRAPS it on read: DynamoDB
// holds the 2-char string `{}` and this query returns the 4-char string `"{}"`.
// The exporter unwraps exactly one layer. Do not "fix" that by unwrapping here
// — the backend's exportParameters owns the rule, and doing it twice
// double-decodes. Verified live 2026-08-16 (FNP-1010).
export const getPlaybookForExport = `
   query getPlaybookForExport($id:ID!) {
       getPlaybook(id:$id) {
         id
         name
         displayName
         description
         category
         status
         inputSchema
         phases {
           id
           name
           displayName
           description
           position
           steps {
             id
             phaseId
             name
             displayName
             description
             position
             taskStateName
             targetService
             targetOperation
             parameters
           }
         }
       }
}`;
